export default "__VITE_ASSET__oxC9ETmK__"